export const utils_iam_iframe = window.self !== window.top